export enum ItemTypesEnum {
  FLIGHT = 'FlightItem',
  FLIGHT_FARE = 'FlightFare',
  EXTRA = 'ExtraService',
  HOTEL = 'Hotel',
  TRANSFER = 'Transfer',
  EXCURSION = 'Excursion',
  INSURANCE = 'Insurance'
}
export default ItemTypesEnum;
